<template>
  <v-dialog :content-class="theContentClass" v-model="showDialog" :fullscreen="fullscreen" scrollable v-bind="$attrs">
    <v-card dense>
      <v-card-title class="pa-1">
        <div class="d-flex align-center" style="width:100%">
          <v-btn icon small @click="onCloseClick" title="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <p class="text-h6 font-weight-black flex-grow-1 my-0 mx-1">
            Sentença: 
          </p>

          <v-btn large icon @click="onFullscreenClick" >
            <v-icon v-if="!fullscreen">mdi-fullscreen</v-icon>
            <v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text class="my-2" :style="{height: fullscreen? 'calc(100vh - 58px)': 'calc(90% - 58px)'}">
        <tj-item-full :item="item" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import "@/components/tj-item-full.vue"
  import Vue from "vue"

  export default Vue.component("tj-sentenca-dialog", {
    props: {
      value: Boolean,
      item: Object,
      fullscreen: Boolean,
      contentClass: [String, Object, Array]
    },

    model: {
      prop: "value",
      event: "update"
    },

    data(){
      return {
      }
    },

    computed: {
      theContentClass(){
        const classes = "tj-sentenca-dialog"
        return this.contentClass? classes + " " + this.getContentClass(this.contentClass): classes 
      },

      showDialog: {
        get(){
          return this.value
        },
        set(v){
          if(v !== this.value) this.$emit("update", v)
        }
      }
    },

    methods: {
      onCloseClick(){
        this.showDialog = !this.showDialog
      },

      onFullscreenClick(){
        this.$emit("update:fullscreen", !this.fullscreen)
      },

      getContentClass(v){
        if(!v) return ""
        if(v.constructor === String) return v;
        if(v.constructor !== Array) v = Object.keys(v).reduce((res, key) => {
          if(v[key]) res.push(key)
          return res
        }, [])
        return v.join(" ")
      }
    }
  })
</script>
